/*
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2021-11-15 10:20:46
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \h5-vip\src\store\index.js
 */
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        code: "",
        referKey: "",
    },
    mutations: {
        // 保存 银行编码
        saveCode(state, code) {
            state.code = code
        },
        // 保存邀请码
        saveReferKey(state, referKey) {
            state.referKey = referKey
        }
    }
})